var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.partnerCode==='uzima_ug')?_c('UzimaUg'):(_vm.partnerCode==='nile_ug')?_c('NileUg'):_c('Default')}
var staticRenderFns = []

export { render, staticRenderFns }